import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@app/store/types';

export type GuideId = 'documents' | 'templates';

export interface GuideDisplayState {
  banner: boolean;
}

const initialState: Record<GuideId, GuideDisplayState> = {
  documents: {
    banner: true,
  },
  templates: {
    banner: true,
  },
};

const GuidesDisplayStateSlice = createSlice({
  name: 'guidesDisplayState',
  initialState,
  reducers: {
    turnOnGuideBanner(state, action: PayloadAction<{ guideId: GuideId }>) {
      state[action.payload.guideId].banner = true;
    },
    turnOffGuideBanner(state, action: PayloadAction<{ guideId: GuideId }>) {
      state[action.payload.guideId].banner = false;
    },
    toggleGuideBanner(state, action: PayloadAction<{ guideId: GuideId }>) {
      state[action.payload.guideId].banner = !state[action.payload.guideId].banner;
    },
  },
});

export const { turnOnGuideBanner, turnOffGuideBanner, toggleGuideBanner } =
  GuidesDisplayStateSlice.actions;

export const { reducer } = GuidesDisplayStateSlice;

/**
 * 온보딩 배너와 툴팁의 표시 여부를 반환한다.
 */
export const getOnboardingBannerDisplay = (guideId: GuideId) => (state: RootState) =>
  state.onboardingBanner[guideId];
